import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function UpdateImageDialog ({
  open,
  images,
  removeImage,
  handleClose,
  uploadImage,
  handleChange,
  addImage,
  setAddImage,
  setImages,
  manageImageData,
  // deleteImage
}) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle>{"Update Image"}</DialogTitle>
        <form style={{ width: "400px" }} onSubmit={e => uploadImage(e, "update")}>
          <DialogContent style={{ paddingBottom: 0, paddingTop: 0 }}>
            <DialogContentText id='alert-dialog-slide-description'>
              <div style={styles.container}>
                {/* Image Previews */}
                <div style={styles.previewContainer}>
                  <div style={styles.imageWrapper}>
                    <img
                      src={
                        addImage?.image
                          ? URL.createObjectURL(addImage?.image)
                          : manageImageData?.image
                      }
                      alt={`preview`}
                      style={styles.image}
                    />
                    {addImage?.image && (
                      <button
                        onClick={() => {
                          setAddImage({});
                          setImages([]);
                        }}
                        style={styles.removeBtn}
                      >
                        ✖
                      </button>
                    )}
                  </div>
                </div>
                {/* Upload Box */}
                <label style={styles.uploadBox}>
                  <input
                    name='image'
                    type='file'
                    required
                    accept='image/*'
                    value={handleChange?.image}
                    onChange={handleChange}
                    style={{ display: "none" }}
                  />
                  <div style={styles.uploadContent}>
                    <CloudUploadOutlinedIcon fontSize='60px' sx={{ fontSize: "60px" }} />
                    <p>Drop files here or click to upload</p>
                  </div>
                </label>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <div onClick={() => deleteImage()}>Delete</div> */}
            <Button onClick={handleClose}>Cancel</Button>
            <Button type='submit'>Upload</Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "90%",
    minWidth: "100%",
    margin: "auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "160px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
    margin: "auto",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
